import { render, staticRenderFns } from "./Parallax.vue?vue&type=template&id=1b20235c&scoped=true&"
import script from "./Parallax.vue?vue&type=script&lang=ts&"
export * from "./Parallax.vue?vue&type=script&lang=ts&"
import style0 from "./Parallax.vue?vue&type=style&index=0&id=1b20235c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b20235c",
  null
  
)

export default component.exports